import { ActionReducerMapBuilder, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { IBalanceOper, IDebugState } from ".";

export interface IExportBalanceOperationsResponse {
    result: boolean;
};

export const exportBalanceOperation = createAsyncThunk<IExportBalanceOperationsResponse, IBalanceOper>(
    'debug/exportBalanceOperation',
    async (oper: IBalanceOper) => await api.debug.exportBalanceOperation(oper)
);

const exportBalanceOperationHandler = (builder: ActionReducerMapBuilder<IDebugState>) => {
    builder
        .addCase(exportBalanceOperation.pending, (state: IDebugState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(exportBalanceOperation.fulfilled, (state: IDebugState) => {
            state.loading = false;
        })
        .addCase(exportBalanceOperation.rejected, (state: IDebugState) => {
            state.loading = false;
            state.error = 'Unable to export balance operations';
        });
};

export default exportBalanceOperationHandler;